import { CityCard } from './CityCard';
import { QuickAccess } from './QuickAccess';
import {
    type LandingContents,
    type LandingContentsDefaultTabEnum,
    type LandingContentsFaqsInner,
    type LandingContentsLinkBoxInner,
    type LandingContentsParentEnum,
    LandingContentsQuickAccessLayoutEnum,
} from '@clients/ContentApi';
import { type SearchMode } from '@utils/types';

export default class LandingContent {
    constructor(data: LandingContents) {
        this.h1 = data.h1Title ?? '';
        this.title = data.customPageTitle ?? '';
        this.cityName = data.cityName ?? '';
        this.description = data.customPageDescription ?? '';
        this.parent = data.parent;
        this.url = data.url;
        this.body = data.body;
        this.faqs = data.faqs || [];
        this.linkBox = data.linkBox?.slice(0, 20) || [];
        this.mode = data.mode as SearchMode;
        this.defaultTab = data.defaultTab;
        this.redirectUrl = data.redirectUrl;
        this.redirectErrorCode = data.redirectErrorCode;
        this.cityCards = data.CityCards?.map(card => new CityCard(card)) ?? [];
        this.cityCardsTitle = data.CityCardTitle;
        this.quickAccessItems =
            data.QuickAccessItems?.map(access => new QuickAccess(access)) || [];
        this.quickAccessLayout =
            data?.QuickAccessLayout ||
            LandingContentsQuickAccessLayoutEnum.DoubleRow;
    }

    h1: string;
    title: string;
    cityName: string;
    description: string;
    parent?: LandingContentsParentEnum;
    url: string;
    body?: string;
    faqs: LandingContentsFaqsInner[];
    linkBox: LandingContentsLinkBoxInner[];
    mode?: SearchMode;
    defaultTab?: LandingContentsDefaultTabEnum;
    redirectUrl?: string;
    redirectErrorCode?: number;
    cityCardsTitle?: string;
    cityCards: CityCard[];
    quickAccessItems: QuickAccess[] = [];
    quickAccessLayout: LandingContentsQuickAccessLayoutEnum =
        LandingContentsQuickAccessLayoutEnum.SingleRow;

    toJSON() {
        return { ...this };
    }
}
